export default __webpack_public_path__ + "static/media/Mont-Regular.48fedf56.ttf";